const MONTHS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

export function parseEventDate(str) {
  if (!str) return null;
  const s = String(str).trim();
  const iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3]);
  const named = s.match(/([A-Za-z]+)\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/);
  if (named) {
    const m = MONTHS.findIndex((name) => name.startsWith(named[1].toLowerCase().slice(0, 3)));
    if (m >= 0) return new Date(+named[3], m, +named[2]);
  }
  const numeric = s.match(/(\d{1,2})\s+([A-Za-z]+)\.?,?\s+(\d{4})/);
  if (numeric) {
    const m = MONTHS.findIndex((name) => name.startsWith(numeric[2].toLowerCase().slice(0, 3)));
    if (m >= 0) return new Date(+numeric[3], m, +numeric[1]);
  }
  const fallback = new Date(s);
  return isNaN(fallback.getTime()) ? null : fallback;
}

export function upcomingEvents(events, now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return (events || [])
    .map((event, index) => ({ event, index, when: parseEventDate(event.date) }))
    .filter(({ when }) => !when || when >= today)
    .sort((a, b) => {
      if (!a.when && !b.when) return a.index - b.index;
      if (!a.when) return 1;
      if (!b.when) return -1;
      return a.when - b.when || a.index - b.index;
    })
    .map(({ event }) => event);
}
